import ButtonGroup from '../button/src/button-group';

ButtonGroup.install = function(Vue) {
  Vue.component(ButtonGroup.name, ButtonGroup);
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/button-group/index.js